import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import Prompt from '../../Prompt/Prompt';

import {
  TXTCLI_Please_login_to_your_original__ELL,
  TXTCLI_Your_details_have_already_been_ELL,
  TXTWCL_Okay
} from './RMFExistingAccount.messages.json';
import { messageText } from './RMFExistingAccount.scss';

interface Props {
  onClose: () => void;
}

const RMFExistingAccount: React.FC<Props> = ({ onClose }) => (
  <Prompt
    onClose={onClose}
    variant="default"
    title={{ translation: TXTCLI_Your_details_have_already_been_ELL }}
    primaryButton={{ translation: TXTWCL_Okay }}
    onPrimaryButtonClick={onClose}
  >
    <div className={messageText}>
      <Translation
        tagName="p"
        {...TXTCLI_Please_login_to_your_original__ELL}
        values={{
          a: (msg: React.ReactNode) => (
            <ResolverLink resolverTag={ResolverTag.ContactSupport}>{msg}</ResolverLink>
          )
        }}
      />
    </div>
  </Prompt>
);

export default RMFExistingAccount;
